export enum ColorTypeEnum {
    DarkBlue = 1,
    Red = 2,
    Yellow = 3,
    Green = 4,
    Silver = 5,
    Brown = 6,
    White = 7,
    Black = 8,
    Orange = 9,
    Purple = 10,
    Blue = 11,
    Maroon = 12,
    DarkGreen = 13,
    Gray = 14,
    Bronze = 15,
    Magenta = 16,
    LightBlue = 17
}
